import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

export const OuterContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  alignItems: "center",
  height: "100%",
  justifyContent: "space-between",
});
export const Container = styled(Grid)({
  position: "relative",
});
export const Background = styled(Grid)({
  position: "relative",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
});
export const IconContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "animate",
})<{ animate?: boolean }>(
  {
    position: "absolute",
    right: -15,
    top: 5,
    width: "45%",
    height: "45%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ({ animate }) => ({
    ...(animate && {
      "@keyframes opacityAnimation": {
        from: {
          opacity: 1,
        },
        to: {
          opacity: 0,
        },
      },
      animation: "opacityAnimation 0.5s infinite alternate",
    }),
  })
);
export const ContentContainer = styled(Grid)({
  position: "absolute",
  top: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  justifyContent: "center",
});
export const MainInfo = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  whiteSpace: "normal",
}));
export const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  textAlign: "center",
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light,
}));
